import { useFormContext } from "react-hook-form";
import { FieldConfig } from "../../formConfig";

export default function TextAreaField({ field }: { field: FieldConfig }) {
  const { register } = useFormContext();
  return <textarea id={field.id} autoComplete="nope" data-form-type="other" data-lpignore="true" data-1p-ignore {...register(field.id)} />;
}
